import EQ8 from 'effects/EQ8.js';
import Tone from 'tone';
import {getLogScale} from 'utils/getVolume.js';
import Effects from 'effects/Effects.js';
import ChannelStripEffects from './channel/ChannelStripEffects.js';

const FilterEffect = Effects.FilterEffect;

const MIN_FREQUENCY = 0;
const MAX_FREQUENCY = 14000;
const CHANGE_TIME = 0.01;

class MixEffects {
    constructor(sequencerEngine, input, output) {
        this.input = input;
        this.output = output;
        this.sequencerEngine = sequencerEngine;

        this.eq = new EQ8(sequencerEngine, false);
        this.auxSend = new Tone.Gain(0);

        this.getLowEQ().frequencyParameter.set(250);
        this.getMidEQ().frequencyParameter.set(1000);
        this.getMidEQ().qParameter.set(0.9);
        this.getHighEQ().frequencyParameter.set(3400);

        this.input.connect(this.eq.effectNode);
        this.eq.outputNode.connect(this.auxSend);

        this.hp = new FilterEffect(sequencerEngine, false);
        this.hp.hipass();
        this.lp = new FilterEffect(sequencerEngine, false);
        this.lp.lowpass();
        this.hp.cutoffFrequency = 0;
        this.lp.cutoffFrequency = 30000;
        this.eq.connect(this.hp.effectNode);
        this.hp.connect(this.lp.effectNode);
        this.lp.connect(this.output);
    }

    resetFilters() {
        this.hp.cutoffFrequency = 0;
        this.lp.cutoffFrequency = 30000;
    }

    set filter(x) {
        if (x >= 0.5) {
            let ratio = (x - 0.5) / 0.5;
            this.hp.cutoffFrequency = Math.pow(ratio, 4) * 10000 + 5;
            this.lp.cutoffFrequency = 30040;
        } else {
            let ratio = x / 0.5;
            this.hp.cutoffFrequency = 5;
            this.lp.cutoffFrequency = (30000 * Math.pow(ratio, 4)) + 40;
        }
    }

    dispose() {
        this.eq.dispose();
        this.auxSend.dispose();
        this.hp.dispose();
        this.lp.dispose();

        this.auxSend = undefined;
        this.eq = undefined;
        this.input = undefined;
        this.output = undefined;
        this.hp = undefined;
        this.lp = undefined;
    }

    set color(x) {
        this.auxSend.gain.value = x;
    }

    getLowEQ() {
        return this.eq.equalizerPoints[0];
    }

    getMidEQ() {
        return this.eq.equalizerPoints[4];
    }

    getHighEQ() {
        return this.eq.equalizerPoints[7];
    }
}

export default MixEffects;
